import {
  OthersCatalogDocument,
  OthersCatalogQuery,
} from "shared/catalog/OthersCatalog/others-catalog.query.generated";
import { initializeApollo } from "utils/with-apollo.utils";

import { catalogEntryDetails } from "../AvailableCatalog/available-catalog.helper";

export type OthersEntries = Awaited<ReturnType<typeof getOthersEntries>>;

export const getOthersEntries = async () => {
  const apolloClient = initializeApollo();

  const { data } = await apolloClient.query<OthersCatalogQuery>({
    query: OthersCatalogDocument,
  });

  const isBlackFriday =
    data?.websiteSetting?.data?.attributes?.isBlackFriday ?? false;

  return data.othersCatalog?.data?.attributes?.entries?.map((entry) =>
    catalogEntryDetails({
      catalogueEntry: entry,
      entryUpfronts: data?.upfronts,
      isBlackFriday,
    }),
  );
};
